import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import { Helmet } from 'react-helmet';
import Footer from '../../components/light/blog-classic/Footer';
import Header from '../../components/light/blog-classic/Header';
import Blogs from '../../components/light/blog-classic/Blogs';
import Navbar from '../../components/light/creative-agency/Navbar';

export default function LBlogClassic() {
  return (
    <>
      <Helmet>
        <title>Blog & Updates | SPOB Nigeria</title>
        <meta name="description" content="Read the latest news, stories and field updates from SPOB Nigeria on community health, education, culture and development in South West Nigeria." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://spob-nigeria.vercel.app/light/blog-classic" />
        <meta property="og:title" content="Blog & Updates | SPOB Nigeria" />
        <meta property="og:description" content="Read the latest news, stories and field updates from SPOB Nigeria on community health, education, culture and development in South West Nigeria." />
        <meta property="og:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-5.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blog & Updates | SPOB Nigeria" />
        <meta name="twitter:description" content="Latest news and stories from SPOB Nigeria on community health, education and development." />
        <meta name="twitter:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-5.jpg" />
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <Blogs />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
